import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'

import Icon from '../../ui/Icon/Icon'

import media from '../../../services/generateMediaQueries'
import { loungeFormat } from '../../../services/data/dateFormat'

import ZingBrand from '../../../assets/img/brand.webp'
import LoungePassBackground from '../../../assets/img/lounge-pass/lounge-pass-background.png'
import LoungeImage from '../../../assets/img/lounge-pass/lounge-image.png'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  position: relative;
  margin: 3rem auto;
  width: 325px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Content = styled.div`
  background: #ffffff;
`

const Header = styled.div`
  padding-top: 3rem;
  margin-bottom: 30px;
  background-image: url('${LoungePassBackground}');
  background-size: cover;
  background-position: center -25px;
  background-repeat: no-repeat;
`

const HeaderIcon = styled.img.attrs({ src: ZingBrand })`
  display: block;
  width: 115px;
  margin: 0 auto;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
`

const Title = styled.h3`
  font-family: var(--font-family-ayala-display-sans);
  color: white;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin: 0 1rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
`

const DateTime = styled.h2`
  color: white;
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  opacity: 0.5;
  margin: 0;
  position: relative;
  z-index: 1;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 0;
  padding: 2rem 1.6875rem;
  background: #ffffff;
`

const StyledLoungeImage = styled.img`
  display: block;
  margin: 0 auto;
  position: relative;
  bottom: -40px;
  width: 12.5rem;
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function LoungeModal(props) {
  const {
    handleClose,
    show,
    loading,
    onClose,
    children,
    CloseButton,
    zIndex,
    unlimited,
    shouldCloseOnOverlayClick = true,
    ...restProps
  } = props

  const [dateNow, setDateNow] = React.useState(new Date())

  const tick = () => {
    setDateNow(new Date())
  }

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000)

    return () => {
      clearInterval(timerID)
    }
  })

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            <Header>
              <HeaderIcon />
              <Title>Enjoy access to Ayala Malls Customer Lounges.</Title>
              <DateTime>{loungeFormat(dateNow)}</DateTime>
              <StyledLoungeImage src={LoungeImage} />
            </Header>
            <Description>
              Your Zing membership entitles you access
              <br />
              to Customer Lounges at Ayala Malls. Flash your Lounge Pass at the
              Customer Lounge entrance, and you’re good to go.
            </Description>
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

LoungeModal.defaultProps = {}

LoungeModal.propTypes = {}

export default LoungeModal
